import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceAsMarkerController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceAsMarkerController.php
* @route '/api/marker'
*/
const GetWikiPlaceAsMarkerController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiPlaceAsMarkerController.url(options),
    method: 'get',
})

GetWikiPlaceAsMarkerController.definition = {
    methods: ["get","head"],
    url: '/api/marker',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceAsMarkerController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceAsMarkerController.php
* @route '/api/marker'
*/
GetWikiPlaceAsMarkerController.url = (options?: RouteQueryOptions) => {
    return GetWikiPlaceAsMarkerController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceAsMarkerController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceAsMarkerController.php
* @route '/api/marker'
*/
GetWikiPlaceAsMarkerController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiPlaceAsMarkerController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceAsMarkerController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceAsMarkerController.php
* @route '/api/marker'
*/
GetWikiPlaceAsMarkerController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetWikiPlaceAsMarkerController.url(options),
    method: 'head',
})

export default GetWikiPlaceAsMarkerController